<template>

  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h2 class="custom-header-title float-left pr-1 mb-0">
              Sales Orders
            </h2>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- Status tab bar -->
    <b-row class="content-header">
      <b-col
        class="content-header-left booking_content_wrapper mb-2"
        cols="12"
        md="12"
      >
        <b-dropdown
          v-if="isMobile()"
          :text="currentTabTitle"
          variant="outline-primary"
        >
          <b-dropdown-item
            v-for="tab in tabs"
            :key="tab"
            @click="selectTab(tab)"
          >
            {{ tab }} ({{ statusCounts[tab] || 0 }})
          </b-dropdown-item>
        </b-dropdown>
        <b-tabs
          pills
          class="booking__content pr-tabs"
          :nav-class="[isMobile() ? 'd-none' : '']"
        >
          <b-tab
            v-for="tab in tabs"
            :key="tab"
            :active="currentTab === tab"
            @click="selectTab(tab)"
          >
            <template #title>
              <span class="d-none d-sm-inline">{{ tab }} <span class="rounded-number">{{ statusCounts[tab] || 0 }}</span></span>
            </template>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          />

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <a
                href="javascript:void(0)"
                class="nav-link nav-link-search"
                @click="showSearchBar = !showSearchBar"
              >
                <feather-icon
                  icon="SearchIcon"
                  size="21"
                  class="mr-50"
                />
                <span class="align-middle">Search</span>
              </a>
              <b-input-group
                v-if="showSearchBar"
                class="input-group-merge mr-50"
              >
                <b-form-input
                  v-model="searchQuery"
                  placeholder="Search..."
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="searchQuery = ''; showSearchBar = !showSearchBar"
                  />
                </b-input-group-append>
              </b-input-group>
              <b-dropdown
                id="dropdown-sales-order-filter"
                ref="filter_dropdown_sales_order"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="dropdown-modal"
                right
                variant="link"
              >
                <template #button-content>
                  <feather-icon
                    icon="FilterIcon"
                    size="21"
                    class="align-middle mr-50"
                  />
                  <span class="mr-1">Filter</span>
                </template>
                <sales-order-filters
                  :product-type-filter.sync="productTypeFilter"
                  :need-type-filter.sync="needTypeFilter"
                  :payment-status-filter.sync="paymentStatusFilter"
                  :rank-filter.sync="rankFilter"
                  :agency-filter.sync="agencyFilter"
                  :created-at-filter.sync="createdAtFilter"
                  :agent-self-purchase-filter.sync="agentSelfPurchaseFilter"
                  @apply="applyFilters"
                  @emitHideFilter="hideFilter"
                  @emitShowFilter="showFilter"
                />
              </b-dropdown>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refSalesOrdersTable"
        class="position-relative min-height-table"
        :items="itemListData"
        responsive
        :fields="tableColumns"
        primary-key="_id"
        :sort-by.sync="sortBy"
        show-empty
        no-sort-reset
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(stringID)="data">
          <div class="text-nowrap">
            <b-button
              v-if="canViewThisAction('show', 'SalesOrder')"
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="p-0 weight-600 align-middle detail-view-id"
              :to="{ name: 'sales-orders-show', params: { id: data.item._id } }"
            >
              {{ data.item.stringID }}
            </b-button>
            <span
              v-else
              class="text-bold-black"
            >{{ data.item.stringID }}</span>
            <br>
            <small class="">{{ data.item.productType }}</small>
            <br v-if="data.item.lotNo || data.item.packageName">
            <small
              v-if="data.item.lotNo"
              class=""
            >{{ data.item.zoneNo }}-{{ data.item.lotNo }}</small>
            <small
              v-else-if="data.item.packageName"
              class=""
            >{{ data.item.packageName }}</small>
          </div>
        </template>

        <template #cell(needType)="data">
          <div class="text-nowrap">
            <span>{{ needTypeLabel(data.item.needType) }}</span>
          </div>
        </template>

        <template #cell(customerName)="data">
          <div class="text-nowrap">
            <b-button
              v-if="data.item.agentSelfPurchase && canViewThisAction('show', 'Agent') && (data.item.mainAgent || data.item.agent)"
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="weight-600 align-middle detail-view-id"
              :to="data.item.mainAgent
                ? { name: 'agency-agents-show', params: { id: data.item.mainAgent } }
                : { name: 'agency-agents-probationary-show', params: { id: data.item.agent } }"
            >
              {{ data.item.customerName }}
            </b-button>
            <b-button
              v-else-if="canViewThisAction('show', 'Customer') && data.item.customer"
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="weight-600 align-middle detail-view-id"
              :to="{ name: 'customers-customers-show', params: { id: data.item.customer } }"
            >
              {{ data.item.customerName }}
            </b-button>
            <span v-else>{{ data.item.customerName }}</span>
            <br v-if="data.item.agentSelfPurchase">
            <small
              v-if="data.item.agentSelfPurchase"
              class="text-warning font-weight-bold"
            >
              Agent Self-Purchase
            </small>
          </div>
        </template>

        <template #cell(agent)="data">
          <div
            v-if="data.item.mainAgent || data.item.agent"
            class=""
          >
            <b-button
              v-if="canViewThisAction('show', 'Agent')"
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="weight-600 align-middle detail-view-id"
              :to="data.item.mainAgent
                ? { name: 'agency-agents-show', params: { id: data.item.mainAgent } }
                : { name: 'agency-agents-probationary-show', params: { id: data.item.agent } }"
            >
              {{ data.item.agentName }}
            </b-button>
            <b-button
              v-else
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="none"
              class="text-bold-black align-middle not-button"
            >
              {{ data.item.agentName }}
            </b-button>
            <br>
            <span
              v-if="data.item.agentCode"
              class=""
            >
              {{ data.item.agentCode }}
            </span>
          </div>
          <span v-else>––</span>
        </template>

        <template #cell(orderTotal)="data">
          <div class="text-nowrap">
            <span class="text-bold-black">${{ numberFormat(data.item.orderTotal) }}</span>
          </div>
        </template>

        <template #cell(amountPaid)="data">
          <div class="text-nowrap">
            <span class="text-bold-black">${{ numberFormat(data.item.amountPaid) }}</span>
          </div>
        </template>

        <template #cell(status)="data">
          <b-badge
            :variant="resolveOrderStatusVariant(data.item.orderStatus)"
            class="text-capitalize"
          >
            {{ resolveOrderStatusLabel(data.item.orderStatus) }}
          </b-badge>
        </template>

        <template #cell(paymentStatus)="data">
          <b-badge
            v-if="data.item.paymentStatus"
            :variant="resolvePaymentStatusVariant(data.item.paymentStatus)"
            class="text-capitalize"
          >
            {{ resolvePaymentStatusLabel(data.item.paymentStatus) }}
          </b-badge>
          <span v-else>–</span>
        </template>

        <template #cell(purchaseOption)="data">
          <span>{{ purchaseOptionLabel(data.item.paymentType) }}</span>
        </template>

        <template #cell(pendingDept)="data">
          <span>{{ data.item.pendingDept || '–' }}</span>
        </template>

        <template #cell(latestComment)="data">
          <span>{{ data.item.latestComment || '–' }}</span>
        </template>

        <template #cell(createdAt)="data">
          <div class="text-nowrap">
            <span class="">{{ dateFormatWithTime(data.item.createdAt) }}</span>
          </div>
        </template>

        <!-- Column: Actions -->
        <template
          v-if="canViewThisAction('show', 'SalesOrder')"
          #cell(actions)="data"
        >
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              v-if="canViewThisAction('show', 'SalesOrder')"
              :to="{ name: 'sales-orders-show', params: { id: data.item._id } }"
            >
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50">View</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('void', 'SalesOrder') && data.item.orderStatus !== 'Voided' && data.item.orderStatus !== 'Processed'"
              @click="voidOrder(data.item)"
            >
              <feather-icon icon="SlashIcon" />
              <span class="align-middle ml-50">Void</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
    </b-card>

    <div
      v-if="totalSalesOrders > perPage"
      class="mx-2 mb-2"
    >
      <b-row>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-center justify-content-center pagination-content"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalSalesOrders"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            align="center"
            prev-text="Prev"
            next-text="Next"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
              <span>Prev</span>
            </template>
            <template #next-text>
              <span>Next</span>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BCard, BRow, BButton, BCol, BFormInput, BTable, BInputGroup, BInputGroupAppend,
  BPagination, BBadge, BDropdown, BDropdownItem, BTab, BTabs,
} from 'bootstrap-vue'
import { ref, computed, onUnmounted } from '@vue/composition-api'
import Vue from 'vue'
import { useToast } from 'vue-toastification/composition'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
// eslint-disable-next-line import/no-cycle
import useSalesOrderList from './useSalesOrderList'
import salesOrderStoreModule from './salesOrderStoreModule'
import SalesOrderFilters from './SalesOrderFilters.vue'

export default {
  components: {
    BCard,
    BRow,
    BButton,
    BCol,
    BFormInput,
    BTable,
    BPagination,
    BInputGroup,
    BInputGroupAppend,
    BBadge,
    BDropdown,
    BDropdownItem,
    BTab,
    BTabs,
    SalesOrderFilters,

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  methods: {
    hideFilter() {
      this.$refs.filter_dropdown_sales_order.hide(true)
    },
    showFilter() {
      this.$refs.filter_dropdown_sales_order.show(true)
    },
  },
  setup() {
    const showSearchBar = ref(false)
    const SALES_ORDER_APP_STORE_MODULE_NAME = 'app-sales-orders'

    if (!store.hasModule(SALES_ORDER_APP_STORE_MODULE_NAME)) store.registerModule(SALES_ORDER_APP_STORE_MODULE_NAME, salesOrderStoreModule)

    onUnmounted(() => {
      if (store.hasModule(SALES_ORDER_APP_STORE_MODULE_NAME)) store.unregisterModule(SALES_ORDER_APP_STORE_MODULE_NAME)
    })

    const { canViewThisAction } = useAclUtils()
    const toast = useToast()

    const {
      fetchSalesOrders,
      tableColumns,
      perPage,
      currentPage,
      totalSalesOrders,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refSalesOrdersTable,
      refetchData,
      currentDataLength,
      itemListData,

      resolvePaymentStatusVariant,
      resolvePaymentStatusLabel,
      resolveOrderStatusVariant,
      resolveOrderStatusLabel,
      purchaseOptionLabel,

      createdAtFilter,
      productTypeFilter,
      needTypeFilter,
      paymentStatusFilter,
      rankFilter,
      agencyFilter,
      agentSelfPurchaseFilter,
      applyFilters,

      currentTab,
      statusCounts,
      selectTab,
    } = useSalesOrderList()

    if (searchQuery.value) {
      showSearchBar.value = true
    }

    const tabs = ['Processing', 'Action Required', 'Processed', 'Voided', 'Pending My Dept', 'Pending Others', 'All Sales Orders']
    const currentTabTitle = computed(() => `${currentTab.value} (${statusCounts.value[currentTab.value] || 0})`)

    const needTypeLabel = needType => {
      if (needType === 'PRE-NEED') return 'Pre-need'
      if (needType === 'AS-NEED') return 'As-need'
      return needType || '–'
    }

    // Same confirm-then-dispatch flow as SalesOrderDetails.vue's own Void button - list-level
    // shortcut so staff don't need to open the order first just to void it.
    const voidOrder = order => {
      Vue.swal({
        title: `Void Sales Order ${order.stringID}?`,
        html: 'Once you void the Sales Order, this action is irreversible. No notification is sent out to agent or customer.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/alert.png'),
        imageWidth: 80,
        imageHeight: 80,
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'No, go back',
        confirmButtonText: 'Yes, void it',
        customClass: { confirmButton: 'btn btn-danger ml-1 mt-2', cancelButton: 'btn btn-outline-primary mt-2' },
        buttonsStyling: false,
      }).then(result => {
        if (!result.value) return
        store.dispatch('app-sales-orders/voidSalesOrder', { id: order._id })
          .then(() => {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Voided Successfully',
                text: `Sales Order ${order.stringID} has been voided.`,
                icon: 'CheckCircleIcon',
                variant: 'success',
              },
            })
            fetchSalesOrders()
          })
          .catch(error => {
            toast({
              component: ToastificationContent,
              props: {
                title: (error.data && error.data.message) || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
      })
    }

    return {
      fetchSalesOrders,
      tableColumns,
      perPage,
      currentPage,
      totalSalesOrders,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refSalesOrdersTable,
      refetchData,
      showSearchBar,
      currentDataLength,
      itemListData,

      canViewThisAction,
      needTypeLabel,

      resolvePaymentStatusVariant,
      resolvePaymentStatusLabel,
      resolveOrderStatusVariant,
      resolveOrderStatusLabel,
      purchaseOptionLabel,

      createdAtFilter,
      productTypeFilter,
      needTypeFilter,
      paymentStatusFilter,
      rankFilter,
      agencyFilter,
      agentSelfPurchaseFilter,
      applyFilters,

      tabs,
      currentTab,
      currentTabTitle,
      statusCounts,
      selectTab,
      voidOrder,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.rounded-number {
  height: 24px;
  width: 24px;
  background-color: #FFFFFF;
  border-radius: 50%;
  color:#104D9D;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
